import React, { useState } from "react";

import { useDisableBodyScroll } from "../../hooks/useDisableBodyScroll";
import { WarningIcon } from "../SVGIcons";

interface CreditWarningModalProps {
  onClose: (dontShowAgain: boolean) => void; // eslint-disable-line no-unused-vars
  creditLimit: number;
  creditConsumed: number;
  remainingPercentage: number;
}

const CreditWarningModal: React.FC<CreditWarningModalProps> = ({
  onClose,
  creditLimit,
  creditConsumed,
  remainingPercentage,
}) => {
  // モーダル表示時に背景のスクロールを無効化
  useDisableBodyScroll();

  // チェックボックスの状態管理（デフォルトでチェック済み）
  const [dontShowAgain, setDontShowAgain] = useState(true);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* 背景オーバーレイ */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      />

      {/* モーダル本体 */}
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md">
        {/* タイトルバー */}
        <div
          className="text-white px-6 py-3 rounded-t-lg flex items-center"
          style={{ backgroundColor: "#eab308" }}
        >
          <WarningIcon
            className="h-6 w-6 flex-shrink-0"
            style={{ fill: "#ffffff", stroke: "#eab308", color: "#eab308" }}
          />
          <h3 className="text-xl font-bold ml-3">クレジット残量警告</h3>
        </div>

        {/* メッセージ */}
        <div className="p-6">
          <div className="flex items-start mb-4">
            <div className="ml-3 text-left">
              <p className="text-base leading-6 text-gray-900">
                合計クレジットの残りが
                <span className="text-red-600 font-semibold">10%以下</span>
                になりました。
              </p>
            </div>
          </div>
          <div className="bg-gray-100 p-4 rounded-md space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-600">合計クレジット:</span>
              <span className="font-semibold">{creditLimit}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">消費済み:</span>
              <span className="font-semibold">{creditConsumed}</span>
            </div>
            <div className="flex justify-between border-t pt-3">
              <span className="text-gray-600">残り:</span>
              <span className="font-semibold text-red-600">
                {creditLimit - creditConsumed} ({remainingPercentage.toFixed(1)}
                %)
              </span>
            </div>
          </div>
          <label htmlFor="dontShowAgain" className="flex items-center mt-4">
            <input
              type="checkbox"
              id="dontShowAgain"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              className="w-4 h-4"
            />
            <span className="ml-3 text-sm text-gray-700">
              今月中は表示しない
            </span>
          </label>
        </div>

        {/* ボタン */}
        <div className="flex justify-end px-6 py-3 border-t">
          <button
            type="button"
            onClick={() => onClose(dontShowAgain)}
            className="px-6 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            確認しました
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreditWarningModal;
